import React from 'react'
// libs
import { change, getFormValues } from 'redux-form'
import { useDispatch, useSelector } from 'react-redux'
// hooks
import { useModalData } from 'hooks/useShowModal'
// components
import { Modal } from 'components/UI'
// view components
import RecurrenceSettingsForm from './Form'
// constants
import { Forms, Modals } from 'constants/index'
// themes
import { CloseIcon } from 'components/UI/Icons'
// views
import { ModalHeader } from './views'
// utils
import { isNil } from 'lodash'
import { getValueFromOption } from 'utils/form'

const PAPER_PROPS = {
  style: {
    padding: 16
  }
}

const FieldRecurrenceModal: React.FC = () => {
  const dispatch = useDispatch()

  const {
    hideModal,
    modalData: { isOpen, field, initialValues, form = Forms.RISK_TEMPLATE_FORM, dueDateNowOnly }
  } = useModalData({ modalType: Modals.RISK_FIELD_RECURRENCE_MODAL })

  const { formValues } = useSelector<any, any>((state) => ({
    formValues: getFormValues(Forms.RISK_FIELD_RECURRENCE_FORM)(state)
  }))

  if (!isOpen) {
    return null
  }

  const handleCloseModal = () => {
    if (formValues && formValues.dueDateAt && !isNil(formValues.plus) && formValues.plusType) {
      dispatch(
        change(form, field, {
          plus: formValues.plus,
          plusType: getValueFromOption(formValues.plusType),
          dueDateAt: getValueFromOption(formValues.dueDateAt)
        })
      )
    }

    hideModal()
  }

  return (
    <Modal width='xs' isOpen={isOpen} disableRestoreFocus hideModal={handleCloseModal} PaperProps={PAPER_PROPS}>
      <ModalHeader>
        <span> Set Date Rule</span>
        <CloseIcon right={0} onClick={handleCloseModal} />
      </ModalHeader>
      <RecurrenceSettingsForm initialValues={initialValues} dueDateNowOnly={dueDateNowOnly} />
    </Modal>
  )
}

export default FieldRecurrenceModal
